let $ = require('../../../../../../../webpack/node_modules/jquery');
let nunjucks = require('../../../../../../../webpack/node_modules/nunjucks');
require('../../../../../../../webpack/node_modules/jscroll');
let storage = require('./storage')


$(document).ready(function () {
	if(!$('.tx-psr-sortenfinder').length || !window.sortenfinderDirectlinksPluginOnPage) {
		return;
	}
	$('.tx-psr-sortenfinder .filter-species-container').map((i, container) => {
		if($(container).find('button.btn-species').length) {
			$(container).html(
				$(container).find('button.btn-species').sort((a,b) =>$(a).text().localeCompare($(b).text()))
			)
		}
	})

	$(document).on('click', '.tx-psr-sortenfinder .filter-categories__static button.btn-static ', function (event) {
		let button = $(event.target).closest('.btn')
		setStorageFilter (button)
		button.addClass('active')
		window.location.href = window.listUri;
	});

	$(document).on('click', '.tx-psr-sortenfinder .filter-species-container button.btn-species', function (event) {
		let button = $(event.target).closest('.btn')
		setStorageFilter (button)
		button.addClass('active')
		window.location.href = listUri;
	});

	function setStorageFilter (button) {
		let filters = [$(button).data('filter'), $(button).data('parent')].map((fullKey) => {
			if(/^category-/.test('' + fullKey)){
				return {key: 'category', tag: fullKey}
			} else if(/^species-/.test('' + fullKey)) {
				return {key: 'species', tag: fullKey}
			}
		}).filter(item => !!item)
		storage.set('filter', {text:'', discrete: filters})
	}
})

